import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useDataType } from '../../../common/hooks/use-data-type';
import {
    roundSelector,
    seasonSelector,
    performanceChartDataTypeSelector
} from 'store/modules/statspro/performance-chart/selectors';
import { getTranslation } from 'common/react/utils/translations';
import { ToggleInput } from 'common/react/components/ToggleInput';
import { DATA_TYPE } from '../../../common/config/data-type';
import { performanceChartActions } from 'common/store/modules/statspro/performance-chart';

export const dataTypeOptions = [
    {
        label: getTranslation('label.stats.totals'),
        value: DATA_TYPE.TOTALS
    },
    {
        label: getTranslation('label.statspro.perGame'),
        value: DATA_TYPE.PER_GAME
    }
];

export const DataTypeToggle = () => {
    const round = useSelector(roundSelector);
    const season = useSelector(seasonSelector);
    const initialDataType = useSelector(performanceChartDataTypeSelector);

    const { dataType, updateDataType } = useDataType({
        initialDataType,
        onUpdateActionCreator: performanceChartActions.setDataType
    });

    const options = useMemo(() => {
        return dataTypeOptions.map((option) => {
            if (option.value === DATA_TYPE.PER_GAME) {
                return {
                    ...option,
                    disabled: season.id === -1
                };
            }

            return option;
        });
    }, [round, season]);

    return (
        <ToggleInput
            id="performance-chart-data-type-toggle"
            value={
                dataType.type.toLowerCase().includes(DATA_TYPE.TOTALS)
                    ? DATA_TYPE.TOTALS
                    : DATA_TYPE.PER_GAME
            }
            onChange={updateDataType}
            options={options}
        />
    );
};

export default DataTypeToggle;
